import { Box } from "@mui/material";
import React from "react";

type LayoutWrapperProps = {
  children: React.ReactNode;
  itemsPerRow?: number;
  spacing?: number;
};

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  itemsPerRow = 2,
  spacing = 2,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: `repeat(${itemsPerRow}, 1fr)`,
        },
        gap: spacing,
      }}
    >
      {children}
    </Box>
  );
};

export default LayoutWrapper;
